import React, { useRef, useLayoutEffect } from "react";

// Renders text on ONE line, shrinking the font (down to `minSize`) until it fits
// its ACTUAL rendered width — no ellipsis, ever. The element fills its parent
// (width:100%) and is capped by `maxWidth` when given, so `clientWidth` is exactly
// the space available (min of the container and the cap). Admin-set text sizes are
// therefore overridden by this reactive fit whenever a name would overflow.
export function AutoFitText({ text, maxWidth, baseSize, minSize = 7, className = "", style = {}, testId }) {
    const ref = useRef(null);
    const numeric = typeof maxWidth === "number";
    useLayoutEffect(() => {
        const el = ref.current;
        if (!el) return;
        const fit = () => {
            const avail = el.clientWidth;
            if (!avail) return;
            let s = baseSize;
            el.style.fontSize = `${s}px`;
            let g = 0;
            while (s > minSize && el.scrollWidth > avail && g < 120) {
                s -= 0.5;
                el.style.fontSize = `${s}px`;
                g += 1;
            }
        };
        fit();
        let ro;
        if (typeof ResizeObserver !== "undefined") {
            ro = new ResizeObserver(fit);
            ro.observe(el);
            if (el.parentElement) ro.observe(el.parentElement);
        }
        return () => ro && ro.disconnect();
    }, [text, maxWidth, baseSize, minSize, numeric]);
    return (
        <span
            ref={ref}
            data-testid={testId}
            className={className}
            title={typeof text === "string" ? text : undefined}
            style={{ display: "block", width: "100%", whiteSpace: "nowrap", overflow: "hidden", fontSize: baseSize, maxWidth: numeric ? maxWidth : "100%", ...style }}
        >
            {text}
        </span>
    );
}

export default AutoFitText;
